<div class="container white-bg mb-2">
	<div class="row ">
		<div class="col">
			<div class="container">
				<div class="row">
					<form class="col-12">
						<div class="my-1 p-0 row">
							<h2 for="search-what" class="col-12 no-wrap my-auto ml-2 my-1">جستجو</h2>
							<div class="col p-0 m-0">
								<div class="flex-grow-1 ml-md-3 relative ">
									<input name="q" maxlength="512" autocomplete="off" [(ngModel)]="params.q" autofocus 
										placeholder="جستجوی کاریابی" />
									<i class="fa fa-search pl-2 fs-lg abs-middle left-0"></i>
								</div>
							</div>
							<div class="col-3 p-0 m-0">
								<button type="submit" [routerLink]="['/agent',params]" class="btn btn-yellow rounded-xl fs-lg "
									ga-event="agent-list|{{params.q}}">جستجو</button>
							</div>
						</div>
					</form>
					<div class="col-12" *ngIf="states">
						<h2>استان‌ها</h2>
						<ng-container *ngIf="searching">
							<div *ngFor="let state of states" [class.bold]="params.l==state">
								<a
									[routerLink]="['/agent',{q:params.q||'',l:state}]">{{state}}{{counts[state]?' ('+counts[state]+')':''}}</a>
								<i *ngIf="params.l==state" (click)="setLocation(state)" class="fas fa-times m-1"></i>
							</div>
						</ng-container>
						<div class="container row" *ngIf="!searching">
							<div class="col-12 col-sm-6 col-md-4 col-lg-3 p-2" *ngFor="let state of states">
								<div class="rounded-xl shadow-kp p-2 pointer" [routerLink]="['/agent',{q:params.q||'',l:state}]"
									[class.bold]="params.l==state">
									<a [routerLink]="['/agent',{q:params.q||'',l:state}]">
										{{state}}{{counts[state]?' ('+counts[state]+')':''}}
										<i *ngIf="params.l==state" (click)="setLocation(state)" class="fas fa-times m-1"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-md-8 pt-3 row" *ngIf="searching">
			<div class="col-12 rounded-xl p-3 shadow-kp mt-3" *ngFor="let user of users">
				<div class="row">
					<div class="col-12">
						<span *ngIf="user.Agent.Code" class="float-left fs-sm">کد: {{user.Agent.Code}}</span>
						<h2><a [class.disabled]="!user.Agent.Code"
								[routerLink]="['/agent',user.Agent.Code]">{{user.Agent.Company||('کاریابی '+user.Name)}}
								{{user.Agent.IsLegal?'(حقوقی)':''}}</a></h2>
					</div>
					<div class="col-12">
						<a class="bold"
							[routerLink]="['/agent',{l:Utility.join('،',user.Agent.State,user.Agent.City)}]">{{Utility.join('،',user.Agent.State,user.Agent.City,user.Agent.District)}}</a>
						<ng-container *ngIf="hasDate(user.Agent.EstablishDate)">- تاسیس
							{{user.Agent.EstablishDate|pdate:'[yyyy]'}}
						</ng-container>
						<div>{{user.Agent.Description}}</div>
					</div>
					<div class="col-12">آدرس: {{user.Agent.Address}}</div>
					<div class="col-12">مدیریت: {{user.Agent.Manager}}</div>
					<div class="col-12" *ngIf="user.Agent.Phones?.length">
						تلفن: <a *ngFor="let tel of user.Agent.Phones" href="tel:+{{tel}}"><span
								dir="ltr">{{tel}}</span>&nbsp;&nbsp;</a>
					</div>
					<div class="col-12" *ngIf="user.Agent.Faxes?.length">
						فکس: <a *ngFor="let tel of user.Agent.Faxes" href="tel:+{{tel}}"><span
								dir="ltr">{{tel}}</span>&nbsp;&nbsp;</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>